export default __webpack_public_path__ + "static/media/StarIcon.5b35d4a3.svg";